import { Button } from "@achieve/ascend"
import { MediaImageStandard, Typography } from "components/Contentful"
import { CurrentSvg } from "components/CurrentSvg"
import Link from "next/link"

export const FDRHeader = ({ siteEnv, tp_text, tp_image, linkUrl }) => {
    const handleCall = () => {
        window.location.href = "tel:800-910-0065"
    }
    return (
        <div className="py-4 drop-shadow-md bg-white fixed top-0 left-0 right-0 z-30">
            <div className="flex flex-row justify-between items-center gap-x-5 w-full max-w-[1000px] mx-auto">
                <CurrentSvg siteEnv={siteEnv} width={112} height={48} />
                <Typography
                    content="Get credit card debt relief from America’s top debt relief company."
                    className="whitespace-nowrap text-sm -translate-y-3"
                />
                <div className="flex flex-col items-center gap-2">
                    <div className="flex flex-row gap-4">
                        <Button
                            onClick={handleCall}
                            className="bg-white border-2 border-[#041B93] border-solid text-[#041B93] px-5 py-2 rounded-md"
                        >
                            <Typography
                                content="Call 800-910-0065"
                                className="whitespace-nowrap text-base font-bold text-[#041B93]"
                            />
                        </Button>
                        <Link href={linkUrl} className="no-underline">
                            <Button
                                className="group bg-[#CB000E] px-5 py-2 rounded-md flex items-center gap-2"
                            >
                                <Typography
                                    content="See if you qualify"
                                    className="text-white whitespace-nowrap text-lg font-bold"
                                />
                                <svg
                                    width="14"
                                    height="14"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="stroke-white stroke-2"
                                >
                                    <g className="-translate-x-2 transition-transform duration-100 ease-in-out group-hover:translate-x-0">
                                        <path d="M11.5 22L21.5 12L11.5 2" strokeWidth="4" />
                                        <line
                                            className="opacity-0 transition-opacity duration-75 ease-in-out group-hover:opacity-100"
                                            x1="21"
                                            y1="12"
                                            x2="1"
                                            y2="12"
                                            strokeWidth="4"
                                        />
                                    </g>
                                </svg>
                            </Button>
                        </Link>
                    </div>
                    <div className="flex flex-row gap-2 lg:block">
                        <div className="flex flex-row gap-2 items-center justify-center">
                            <div className="w-[180px] h-[28px]">
                                <MediaImageStandard content={tp_image} />
                            </div>
                            <Typography className="text-black text-base" content={tp_text} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}